// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2KDuG","search":"Settings_search__3yHX4","filter":"Settings_filter__1yoJV"};